const Admin = () => {
    return (
        <>
            ADMIN
        </>
    )

};

export default Admin;